import { Link, NavLink } from "react-router-dom";

import {
  HiHome,
  HiShoppingBag,
  HiUserCircle,
  HiUserGroup,
  HiNewspaper,
} from "react-icons/hi";
import { IoLogIn } from "react-icons/io5";

import Logo from "../../../helpers/Logo/Logo";
import { useState } from "react";

const AdminPcMenu = () => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      <div
        className="h-screen z-10 fixed p-3 bg-transparent
        lg:flex hidden
        2xl:w-[6%] xl:w-[8%] lg:w-[11%] xl:hover:w-[11%] lg:hover:w-[13%]
        transition-all duration-300 ease-in
        hover:transition-all hover:duration-300 hover:ease-out
        animate__animated animate__fadeInRight animate__faster"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div
          className="w-full h-full flex flex-col items-center 
          justify-between rounded-2xl bg-menuBackground"
        >
          {/*  News - Logo - Buttons */}
          <div className="w-full flex flex-col justify-center items-center pt-4">
            {/* Logo */}
            <Link
              to="/Public/Home"
              className={`flex cursor-pointer ${
                isHovered
                  ? "animate__animated animate__fadeInRight animate__fast"
                  : "animate__animated animate__fadeIn animate__fast"
              }`}
            >
              <Logo width={isHovered ? 115 : 65} height={isHovered ? 28 : 16} />
            </Link>
            {/* Buttons */}
            <ul
              className="space-y-5 flex flex-col justify-center items-center 
              tracking-wide mt-10 text-white font-medium text-sm"
            >
              {/* 1 */}
              <li>
                <NavLink
                  to="/Admin/Dashboard/Profile"
                  className={({ isActive }) =>
                    isActive
                      ? "flex items-center justify-center rounded-xl cursor-pointer text-slate-50"
                      : "flex items-center justify-center rounded-xl text-slate-400 hover:text-slate-200 cursor-pointer"
                  }
                >
                  <span
                    className={`flex flex-col justify-center items-center
                      ${
                        isHovered
                          ? "animate__animated animate__fadeInRight animate__fast"
                          : "animate__animated animate__fadeIn animate__fast"
                      }
                    `}
                  >
                    <HiUserCircle size={30} className="mt-1" />
                    {isHovered && <span className="mt-1">پروفایل</span>}
                  </span>
                </NavLink>
              </li>
              {/* 2 */}
              <li>
                <NavLink
                  to="/Admin/Dashboard/Users"
                  className={({ isActive }) =>
                    isActive
                      ? "flex items-center justify-center rounded-xl cursor-pointer text-slate-50"
                      : "flex items-center justify-center rounded-xl text-slate-400 hover:text-slate-200 cursor-pointer"
                  }
                >
                  <span
                    className={`flex flex-col justify-center items-center
                      ${
                        isHovered
                          ? "animate__animated animate__fadeInRight animate__fast"
                          : "animate__animated animate__fadeIn animate__fast"
                      }
                    `}
                  >
                    <HiUserGroup size={30} className="mt-1" />
                    {isHovered && <span className="mt-1">کاربران</span>}
                  </span>
                </NavLink>
              </li>
              {/* 3 */}
              <li>
                <NavLink
                  to="/Admin/Dashboard/Products"
                  className={({ isActive }) =>
                    isActive
                      ? "flex items-center justify-center cursor-pointer text-slate-50"
                      : "flex items-center justify-center text-slate-400 hover:text-slate-200 cursor-pointer"
                  }
                >
                  <span
                    className={`flex flex-col justify-center items-center
                      ${
                        isHovered
                          ? "animate__animated animate__fadeInRight animate__fast"
                          : "animate__animated animate__fadeIn animate__fast"
                      }
                    `}
                  >
                    <HiShoppingBag size={30} className="mt-1" />
                    {isHovered && <span className="mt-1">محصولات</span>}
                  </span>
                </NavLink>
              </li>
              {/* 4 */}
              <li>
                <NavLink
                  to="/Admin/Dashboard/Requests"
                  className={({ isActive }) =>
                    isActive
                      ? "flex items-center justify-center cursor-pointer text-slate-50"
                      : "flex items-center justify-center text-slate-400 hover:text-slate-200 cursor-pointer"
                  }
                >
                  <span
                    className={`flex flex-col justify-center items-center
                      ${
                        isHovered
                          ? "animate__animated animate__fadeInRight animate__fast"
                          : "animate__animated animate__fadeIn animate__fast"
                      }
                    `}
                  >
                    <IoLogIn size={30} className="mt-1" />
                    {isHovered && (
                      <span className="mt-1">درخواست های ورود</span>
                    )}
                  </span>
                </NavLink>
              </li>
              {/* 5 */}
              <li>
                <NavLink
                  to="/Admin/Dashboard/News"
                  className="flex items-center justify-center cursor-pointer text-slate-400 hover:text-slate-200"
                >
                  <span
                    className={`flex flex-col justify-center items-center
                      ${
                        isHovered
                          ? "animate__animated animate__fadeInRight animate__fast"
                          : "animate__animated animate__fadeIn animate__fast"
                      }
                    `}
                  >
                    <HiNewspaper size={30} className="mt-1" />
                    {isHovered && <span className="mt-1">اخبار</span>}
                  </span>
                </NavLink>
              </li>
            </ul>
          </div>
          {/* Exit Button */}
          <div className="w-full flex justify-center items-center border-t border-gray-600">
            <NavLink to="/Public/Home">
              <button
                className={`px-4 py-3 flex flex-col justify-center items-center 
                rounded-md text-slate-400 hover:text-slate-200
                ${
                  isHovered
                    ? "animate__animated animate__fadeInRight animate__fast"
                    : "animate__animated animate__fadeIn animate__fast"
                }`}
              >
                <HiHome size={30} className="mt-1" />
                {isHovered && <span className="mt-1">خانه</span>}
              </button>
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminPcMenu;
